import React, { useMemo } from 'react';
import {
  selectedResultInfoStore,
  useTranslation,
  popupStore,
  RoundStatus,
  toFixed,
} from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';

function ResultRow({ result }) {
  const t = useTranslation();

  const handleClickFairnessIcon = (selectedResult) => {
    selectedResultInfoStore.setSelectedResultInfo(selectedResult);
    popupStore.open({ name: PopUps.CheckHash });
  };

  const oddsRepresentation = useMemo(() => {
    if (result) {
      const totalOdd = result.roundData?.[0].odd
        ? result?.roundData
            .filter((item) => item.odd)
            .reduce((acm, current) => +acm * +current.odd, 1)
        : 0;

      return toFixed(+totalOdd);
    }
    return '';
  }, [result]);

  return (
    <div key={result.roundId} className='results-fairness-check-row'>
      <div className='results-fairness-check-column'>
        <span className='results-fairness-check-id'>{result.roundId}</span>
      </div>
      {/* <div className='results-fairness-check-column'> */}
      {/*  {roundId === roundInfoStore.roundId ? '...' : roundData ? roundData.number : 'UPCOMING'} */}
      {/* </div> */}
      <div className='results-fairness-check-column'>
        {result.status === RoundStatus.Started ? (
          <div className='res-loading-block'>
            <div className='res-loading-block-circle' />
            <div className='res-loading-block-circle' />
            <div className='res-loading-block-circle' />
          </div>
        ) : (
          <p className='res-row-text-upcoming'>
            {result.status === RoundStatus.Upcoming ? t('UPCOMING') : `x${oddsRepresentation}`}
          </p>
        )}
      </div>
      <div
        className='results-fairness-check-column check'
        onClick={() => handleClickFairnessIcon(result)}
      >
        <i className='icon-security results-fairness-check-icon' />
      </div>
    </div>
  );
}

export default ResultRow;
